import { Type } from 'class-transformer';
import { IsDate, IsDefined, IsEnum, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { BaseDto } from '../../@base/base.dto';
import { TokenVaultId } from '../../types';
import { TokenVaultContextDto } from './sub-dto/token-vault-context.dto';
import { TokenVaultActions } from './token-vault-actions.enum';
import { TokenVaultStatuses } from './token-vault-status.enum';
import { TokenVaultVerification } from './token-vault-verification.enum';

export class TokenVaultSummaryDto extends BaseDto<TokenVaultId> {
  @IsString()
  @IsNotEmpty()
  action!: TokenVaultActions;

  @IsEnum(TokenVaultVerification)
  @IsNotEmpty()
  verification!: TokenVaultVerification;

  @IsString()
  @IsNotEmpty()
  token!: string;

  @IsEnum(TokenVaultStatuses)
  @IsNotEmpty()
  status!: TokenVaultStatuses;

  @IsDate()
  @IsNotEmpty()
  expireDate!: Date;

  @IsDate()
  @IsOptional()
  usedDate?: Date;

  @ValidateNested()
  @Type(() => TokenVaultContextDto)
  @IsDefined()
  context!: TokenVaultContextDto;

  @IsOptional()
  payload?: Record<string, unknown>;
}
